import React, { useState } from 'react';
import './Popup Styles/PopUp.css';

const Form = ({ onInputChange }) => {
  const [inputValue, setInputValue] = useState('');

  const handleChange = (e) => {
    setInputValue(e.target.value);
    onInputChange(e.target.value);
  };

  return (
    <div>
      <h3 style={{ marginBottom: "20px", marginTop: "20px" }}>Special Instructions:</h3>
      <textarea
        className='textarea'
        placeholder="Please enter instructions about this item if any."
        value={inputValue}
        onChange={handleChange}
      ></textarea>
    </div>
  );
};

export default Form;
